import React, { FC, useState } from 'react';

import { Badge } from 'components/ui/badge';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';

interface SeoKeywordsFieldProps {
  keywords: string[];
  onChange: (keywords: string[]) => void;
}

export const SeoKeywordsField: FC<SeoKeywordsFieldProps> = ({
  keywords,
  onChange
}) => {
  const [keywordInput, setKeywordInput] = useState('');

  const handleAddKeyword = () => {
    const trimmed = keywordInput.trim();
    if (!trimmed) return;

    const newKeywords = trimmed
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean);

    if (!newKeywords.length) return;

    const merged = [...keywords, ...newKeywords];
    onChange(merged.filter((k, i) => merged.indexOf(k) === i));
    setKeywordInput('');
  };

  const handleRemoveKeyword = (keywordToRemove: string) => {
    onChange(keywords.filter((k) => k !== keywordToRemove));
  };

  return (
    <div className="space-y-2">
      <Label className="block align-top font-sans text-sm font-medium leading-4 text-base-secondaryForeground">
        Keywords
      </Label>
      <Input
        placeholder="Enter keywords, separated by commas"
        value={keywordInput}
        onChange={(e) => setKeywordInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleAddKeyword();
          }
        }}
        className="w-full"
      />
      <p className="font-sans text-xs font-normal leading-4 text-base-mutedForeground">
        Press &apos;Enter&apos; to add a new keyword
      </p>
      {!!keywords.length && (
        <div className="flex flex-wrap gap-2">
          {keywords
            .filter((k, i) => keywords.indexOf(k) === i)
            .map((keyword) => (
              <Badge
                key={keyword}
                variant="secondary"
                className="cursor-pointer pr-1 transition-opacity hover:opacity-80"
                onClick={(e) => {
                  e.preventDefault();
                  handleRemoveKeyword(keyword);
                }}
              >
                {keyword}
                <span className="ml-1 text-xs">×</span>
              </Badge>
            ))}
        </div>
      )}
    </div>
  );
};
